import React, { Component } from 'react';

import { Form, DatePicker } from 'antd';

import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

const FormItem = Form.Item;

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    handleChange(data) {
        const name = this.props.name;
        this.setState({
            value: data[name]
        });

        if (this.props.handleChange) {
            this.props.handleChange({
                [name]: data[name] ? (data[name] + ' 00:00:00') : undefined
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const { label, style, name, rules, getFieldDecorator, allowClear, disabled, placeholder } = this.props;
        const { value } = this.state;
        return (
            <FormItem label={label}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value ? moment(value, dateFormat) : undefined,
                            rules: rules || [{
                                required: true,
                                message: '请选择' + label,
                            }],
                        })(
                            <DatePicker placeholder={placeholder || "请选择日期"}
                                style={style || { width: 240 }}
                                disabled={disabled ? disabled : false}
                                onChange={(date, value) => {
                                    this.handleChange({
                                        [name]: value
                                    });
                                }}
                                value={value ? moment(value, dateFormat) : undefined} format={dateFormat} />
                        )
                    ) : (
                        <DatePicker placeholder={placeholder || "请选择日期" }
                            style={style || { width: 240 }}
                            allowClear={allowClear}
                            disabled={disabled ? disabled : false}
                            onChange={(date, value) => {
                                this.handleChange({
                                    [name]: value
                                });
                            }}
                            value={value ? moment(value, dateFormat) : undefined} format={dateFormat} />
                    )
                }
            </FormItem>
        );
    }
}